import { VueApp } from 'larasnap';
import App from './MultiInput.vue';

export default class extends VueApp {
    static registerAs = 'MultiInput';

    constructor(element) {
        super(element, App);
    }
}
